import { render, staticRenderFns } from "./busi5.vue?vue&type=template&id=56b1735a&"
import script from "./busi5.vue?vue&type=script&lang=js&"
export * from "./busi5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports